import gql from 'graphql-tag';

const statesInfo = `
  id
  code
  name
`;

const municipalityInfo = `
  id
  name
  code
  stateId
`;

export const getMunicipalities = gql`
  query financingMunicipalities($where: FinancingMunicipalitiesWhereInput){
      financingMunicipalities(where: $where){
        ${municipalityInfo}
      }
  }
`;

export const getStates = gql`
query financingStates($where: FinancingStatesWhereInput) {
  financingStates (where: $where){
    ${statesInfo}
  }
}
`;
